export default "__VITE_ASSET__bjdE31yv__"